import React, { useEffect } from 'react'
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom'
import { MainLayout } from '@/components/Layout/MainLayout'
import { LandingPage } from '@/pages/LandingPage'
import { OnboardingPage } from '@/pages/OnboardingPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { StagePage } from '@/pages/StagePage'
import { CreateSessionPage } from '@/pages/CreateSessionPage'
import { JoinSessionPage } from '@/pages/JoinSessionPage'
import { PresenterDashboard } from '@/pages/PresenterDashboard'
import { AIToolsReference } from '@/components/AIToolsReference'
import { EnhancedAdminDashboard } from '@/pages/EnhancedAdminDashboard'
import { useJourneyStore, setNavigateCallback } from '@/stores/journeyStore'
import { usePresentationStore } from '@/stores/presentationStore'

function App() {
  const { user } = useJourneyStore()
  const { isParticipantMode, isPresenterMode } = usePresentationStore()
  const navigate = useNavigate()

  // Set up navigation callback for the journey store
  useEffect(() => {
    setNavigateCallback(navigate)
  }, [navigate])

  return (
    <Routes>
      {/* Professional landing page (always accessible) */}
      <Route path="/landing" element={<LandingPage />} />
      
      {/* Root route - redirect authenticated users to dashboard */}
      <Route path="/" element={user ? <Navigate to="/dashboard" replace /> : <LandingPage />} />
      
      {/* Onboarding route */}
      <Route path="/onboarding" element={<OnboardingPage />} />
      
      {/* Public routes that don't require user setup */}
      <Route path="/join/:sessionId" element={<JoinSessionPage />} />
      <Route path="/create-session" element={<CreateSessionPage />} />
      <Route path="/presenter" element={<PresenterDashboard />} />
      <Route path="/overview" element={<StagePage />} />
      <Route path="/ai-tools-reference" element={<AIToolsReference />} />
      <Route path="/admin" element={<EnhancedAdminDashboard />} />
      
      {/* Protected routes that require user setup */}
      {user && (
        <Route path="/" element={<MainLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/stage/:stageId" element={<StagePage />} />
        </Route>
      )}
      
      {/* Fallback routes for unauthenticated users */}
      {!user && (
        <>
          <Route path="/dashboard" element={<Navigate to="/landing" replace />} />
          <Route path="/stage/:stageId" element={<Navigate to="/landing" replace />} />
        </>
      )}
    </Routes>
  )
}

export default App